export class RogueMetrics {
  rogueAnalysisMonth: Date;
  caseMonth: number;
  caseYear: number;
  caseDate: string;
  rogueCount: number;
  rogueAverage: number;
  rogueStandardDeviation: number;
  upperControlLimit: number;
  upperControlLimitExceedance: number;
  orderId: number;
}
